import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fmtL, fmtTime } from "@/lib/api";
import { PageHeader, Stat, StatusPill, Spinner } from "@/components/opl/Common";

export default function Dashboard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/dashboard").then((r) => setD(r.data)); }, []);
  if (!d) return <Spinner />;
  return (
    <div data-testid="admin-dashboard">
      <PageHeader title="Control Center" eyebrow="OPL Season 6" crumbs={["Dashboard"]}>
        <StatusPill status={d.status} big />
        <Link to="/admin/live" className="gold-bg px-4 py-2 rounded-full text-sm font-bold" data-testid="dashboard-live-btn">Open auction console</Link>
      </PageHeader>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <Stat label="Clubs" value={d.clubs} testid="stat-clubs" />
        <Stat label="Registered teams" value={d.teams} testid="stat-teams" />
        <Stat label="Registered players" value={d.total_players} sub={`${d.approved_players} approved`} testid="stat-players" />
        <Stat label="Remaining in pool" value={d.remaining} testid="stat-remaining" />
        <Stat label="Players sold" value={d.sold} testid="stat-sold" />
        <Stat label="Players unsold" value={d.unsold} testid="stat-unsold" />
        <Stat label="Total expenditure" value={fmtL(d.total_spent)} accent testid="stat-spent" />
        <Stat label="Available team purse" value={fmtL(d.total_unspent)} sub={`of ${fmtL(d.total_purse)}`} testid="stat-purse" />
      </div>
      <div className="grid lg:grid-cols-2 gap-5 mt-8">
        <div className="surface rounded-2xl p-5">
          <p className="eyebrow mb-3">Latest bids</p>
          {d.recent_bids.map((b) => <div key={b.id} className="flex justify-between text-sm py-2 border-b border-white/5"><span>{b.player_name} · <span className="text-slate-400">{b.team_name}</span></span><span className="num">{fmtL(b.amount)}</span></div>)}
          {!d.recent_bids.length && <p className="text-sm text-slate-500">No bids yet</p>}
        </div>
        <div className="surface rounded-2xl p-5">
          <p className="eyebrow mb-3">Recent activity</p>
          {d.recent_activity.map((a) => <div key={a.id} className="flex justify-between text-sm py-2 border-b border-white/5"><span><b className="text-slate-200">{a.user_name}</b> <span className="text-slate-400">{a.action}</span></span><span className="text-xs text-slate-500">{fmtTime(a.created_at)}</span></div>)}
        </div>
      </div>
    </div>
  );
}
